import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Étape d'une tournée : pastille de la couleur de l'expert, icône du lieu du
// rendez-vous, et numéro d'ordre de passage (1, 2, 3…) pour suivre le trajet.
//
// Deux différences avec MapMarker, qui sert aux autres cartes :
//   - le marqueur est centré sur la coordonnée (google-map-react place le coin
//     supérieur gauche de l'enfant sur le point), pour tomber sur le tracé de
//     l'itinéraire et non à côté ;
//   - le numéro est une pastille lisible, pas du texte nu collé à l'icône.
export default class TourMarker extends Component {
  render() {
    const { color, icon, order, title, onOpenModal } = this.props;

    return (
      <div
        title={title}
        onClick={() => (onOpenModal ? onOpenModal() : null)}
        style={{
          position: "relative",
          transform: "translate(-50%, -50%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "26px",
          height: "26px",
          borderRadius: "50%",
          backgroundColor: color,
          border: "2px solid #ffffff",
          boxShadow: "0 1px 4px rgba(0, 0, 0, 0.4)",
          cursor: "pointer",
        }}
      >
        <FontAwesomeIcon
          icon={icon}
          style={{ fontSize: "12px", color: "#ffffff" }}
        />
        <span
          style={{
            position: "absolute",
            top: "-9px",
            right: "-9px",
            minWidth: "17px",
            height: "17px",
            padding: "0 3px",
            borderRadius: "9px",
            border: `1px solid ${color}`,
            backgroundColor: "#ffffff",
            color: color,
            fontSize: "10px",
            fontWeight: "bold",
            lineHeight: "15px",
            textAlign: "center",
          }}
        >
          {order}
        </span>
      </div>
    );
  }
}
